import React from 'react';
import { css, useTheme } from '@emotion/react';
import { BirdiTheme } from '@birdi/theme';
import HelloSVG from '@birdi/icons/illustration-hello.svg';
import { CreateDropdown } from '../common/map-dashboard-header/create-dropdown';
import { useMetaSelector } from '../meta/reducer';

/**
 * Dashboard greeting header: a "Hello <name>," row with the Create action.
 * Map search lives in Global Search in the top nav. Renders above the
 * assistant hero (see Dashboard).
 */
export const GetStarted: React.FC = () => {
  const meta = useMetaSelector();
  const theme = useTheme();

  return (
    <div
      css={(theme: BirdiTheme) => css`
        background: ${theme.mono0};
        border-radius: 1em;
        margin-bottom: 0.5em;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.5em 0.75em;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 8px;
          `}
        >
          <div
            css={css`
              font-size: 2.5em;
              margin-right: 0.25em;
            `}
          >
            <HelloSVG />
          </div>
          <h2
            css={css`
              margin: 0;
              font-weight: 700;
              color: ${theme.midnight};
              /* Match the hero's "Welcome back!" heading size. */
              font-size: 1.25em;
            `}
          >{`Hello ${meta.fname},`}</h2>
        </div>
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 0.75em;
          `}
        >
          {/* The dropdown directly — MapDashboardHeader adds a section
              border-bottom that reads as a stray underline here. */}
          <CreateDropdown />
        </div>
      </div>
    </div>
  );
};
